module.exports = __webpack_public_path__ + "img/project.98c44037.png";